export default __webpack_public_path__ + "static/media/3.b64548d1.jpg";